export default function getResource(label) {
    const resources = {
        sectionTitle: 'Rouge-Only Rewards',
        rougeBadge: 'ROUGE'
    };
    return resources[label];
}
